import { Box, Card, Typography } from "@mui/material";

export default function RapportCard({ item, onClick, selected = false }) {
  console.log("Report Item:", item);

  const reportType = (item?.report_type || "").toLowerCase();
  const isFlashReport = reportType === "flash_report";
  const validationStatus =
    typeof item?.validation_status === "boolean" ? item.validation_status : true;
  const riskReportTitle = validationStatus
    ? "Risk Report With validation"
    : "Risk Report ( Automatic)";
  const displayTitle = isFlashReport ? "Flash Report" : riskReportTitle;

  function formatDate(dateStr) {
    if (!dateStr || typeof dateStr !== "string") return "";
    const [datePart] = dateStr.split(" ");
    const [day, month, year] = datePart.split("-");
    if (!day || !month || !year) return dateStr;

    const months = [
      "January","February","March","April","May","June",
      "July","August","September","October","November","December",
    ];
    const monthIdx = parseInt(month, 10) - 1;
    const monthName = months[monthIdx] || month;
    return `${day} ${monthName} ${year}`;
  }

  const scenarios = Array.isArray(item?.associated_scenarios)
    ? item.associated_scenarios
    : [];

  return (
    <Card
      onClick={onClick}
      sx={{
        position: "relative",
        padding: "14px 15px 14px 18px",
        marginBottom: "12px",
        cursor: "pointer",
        border: "1px solid rgba(0, 0, 0, 0.08)",
        boxShadow: selected ? "0 3px 12px rgba(15, 110, 86, 0.12)" : "none",
        "&:before": {
          content: '""',
          position: "absolute",
          left: 0,
          top: 12,
          bottom: 12,
          width: selected ? 4 : 0,
          borderRadius: "0 4px 4px 0",
          backgroundColor: "#0F6E56",
          transition: "width 120ms ease",
        },
        "&:hover": { boxShadow: "0 4px 18px rgba(0, 0, 0, 0.1)" },
      }}
      >
        <Box
          sx={{
            fontSize: "1rem",
            fontWeight: 600,
            marginBottom: "8px",
            color: selected ? "#085041" : "text.primary",
          }}
        >
        {displayTitle}
        </Box>

      {/* Hide scenarios for flash report */}
      {!isFlashReport && (
        <Box sx={{ marginBottom: "12px", color: "text.secondary" }}>
          <Typography variant="body2" sx={{ marginBottom: "8px" }}>
            Evaluated Scenarios :
          </Typography>

          {scenarios.length > 0 ? (
            <ul style={{ paddingLeft: "20px", margin: 0 }}>
              {scenarios.map((scenario, xid) => (
                <li key={xid} style={{ listStyleType: "disc", marginLeft: "20px" }}>
                  <Typography
                    variant="body2"
                    sx={{
                      display: "-webkit-box",
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                    }}
                  >
                    {scenario?.title}
                    {scenario?.title ? "." : ""}
                  </Typography>
                </li>
              ))}
            </ul>
          ) : (
            <Typography variant="body2">N/A</Typography>
          )}
        </Box>
      )}

      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <Box sx={{ flex: "start", fontSize: "0.875rem", color: "text.secondary" }}>
          {formatDate(item?.date)}
        </Box>
      </Box>
    </Card>
  );
}
